function hasNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}

export function isManualAudioCompleteDoc(data) {
  if (!data || typeof data !== "object") return false;

  const upload = typeof data.upload === "string" ? data.upload : null;
  const status = typeof data.status === "string" ? data.status : null;

  if (upload === "complete" || status === "complete") {
    return true;
  }

  if (data.completedAt) {
    return true;
  }

  return (
    hasNonEmptyString(data.audioPath) ||
    hasNonEmptyString(data.audioDownloadURL) ||
    hasNonEmptyString(data.videoPath) ||
    hasNonEmptyString(data.videoDownloadURL) ||
    hasNonEmptyString(data.metadataPath)
  );
}
